export default "__VITE_ASSET__Bz$DsPDt__"